<sim-base-chip-input
	#simUserSimBaseChipInputComponent
	[formState]="userFc"
	[label]="label"
	[placeholder]="placeholder"
	[debounceConfig]="{time: 200}"
	[autoCompleteValues]="autoCompleteData"
	[matAutoCompleteDisplayType]="'SimUser'"
	[displayFn]="displayUser"
	[canAddNewItem]="hasNewUserOption"
	[isMultiSelect]="canSelectMultipleUsers"
	[isAutofocusEnabled]="isAutofocusEnabled"
	(itemClicked)="openUserCardDialog($event)"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
	(createNewItemClicked)="createNewUser()"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
